import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["pagyForm"];

  connect() {
    console.log("Pagy controller connected");
  }

  // This is used by the preline pagy component to submit the form when a page is clicked
  // see current usage in the following pages, i.e. flower selection page, and passage selection page.
  submit(event) {
    if (!this.hasPagyFormTarget) return;
    event.preventDefault();
    
    const linkUrl = new URL(event.currentTarget.href, window.location.origin);
    const actionUrl = new URL(this.pagyFormTarget.action, window.location.origin);
    linkUrl.searchParams.forEach((value, key) => actionUrl.searchParams.set(key, value));
    this.pagyFormTarget.action = actionUrl.toString();
    this.pagyFormTarget.requestSubmit();
  }
}
